// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"5358fb55","90":"4efceff3","258":"527a9c6a","298":"e661a2ed","372":"f3ccc735","627":"dba9be73","929":"b3763d61"}[chunkId] + ".chunk.js";
};